import { Component } from '@angular/core';
import { SearchService } from '../../search/search.service';

@Component({
  selector: 'lfwms-assign-pick-location-popup',
  templateUrl: './assign-pick-location-popup.component.html',
  styleUrls: ['./assign-pick-location-popup.component.css']
})
export class AssignPickLocationPopupComponent {

  public searchService: SearchService;

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/assign-pick-location-popup/assign-pick-location-popup.component.ts